// lib
import { createSelector } from 'reselect';

// type
import { ICMSPageState } from './types';

export const app = (state: { cms: ICMSPageState }): ICMSPageState => state.cms;

export const getCMSData = createSelector([app], (data): object => data.cmsData);

export const isFetching = createSelector([app], (data): boolean => data.isFetching);

export const isFetchingError = createSelector([app], (data): boolean => data.isFetchingError);

export const isNotFound = createSelector([app], (data): boolean => data.isNotFound);
